import { useEffect, useState } from "react";
const baseUrl = process.env.REACT_APP_API_BASE_URL

const useParticipants = () => {
    const [tmminAktif, setTmminAktif] = useState(0);
    const [tmminPasif, setTmminPasif] = useState(0);
    const [tamAktif, setTamAktif] = useState(0);
    const [tamPasif, setTamPasif] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchParticipants = async () => {
            if (!baseUrl) {
                setError("REACT_APP_API_BASE_URL tidak ditemukan");
                setLoading(false);
                return;
            }

            try {
                const res = await fetch(`${baseUrl}participants/read-for-user`);

                if (!res.ok) {
                    throw new Error("Gagal fetch data peserta");
                }

                const data = await res.json();
                const result = data?.[0];

                if (!result) {
                    throw new Error("Data peserta kosong");
                }

                setTmminAktif(result.tmmin_peserta_aktif || 0);
                setTmminPasif(result.tmmin_peserta_pasif || 0);
                setTamAktif(result.tam_peserta_aktif || 0);
                setTamPasif(result.tam_peserta_pasif || 0);

                setLoading(false);
            } catch (err) {
                setError(err.message || "Terjadi kesalahan saat fetch data");
                setLoading(false);
            }
        };

        fetchParticipants();
    }, []);

    return {
        tmminAktif,
        tmminPasif,
        tamAktif,
        tamPasif,
        loading,
        error,
    };
};

export default useParticipants;
